var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBoxJiffyCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 25 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M21.917 7.49 12 13m0 0L2.083 7.49M12 13v11.083m2.333-.713-1.427.793c-.33.183-.496.276-.671.311a1.2 1.2 0 0 1-.47 0c-.175-.035-.34-.128-.671-.311L2.46 19.366c-.35-.194-.524-.29-.651-.429a1.2 1.2 0 0 1-.25-.424c-.059-.179-.059-.379-.059-.778v-9.47c0-.4 0-.6.059-.778.052-.158.137-.303.25-.425.127-.138.302-.235.651-.43l8.634-4.795c.33-.184.496-.276.671-.312.155-.032.315-.032.47 0 .175.036.34.128.672.312l8.633 4.796c.35.194.524.291.651.43.113.121.198.266.25.424.059.178.059.378.059.778v5.318M6.75 4.25l10.5 5.833M16.667 20 19 22.333l4.667-4.667"
})));
export default SvgBoxJiffyCheck;